import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "kt_aside_menu_wrapper",
  ref: "scrollElRef",
  class: "hover-scroll-overlay-y my-5 my-lg-5",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-dependencies": "#kt_aside_logo, #kt_aside_footer",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-offset": "0",
  "data-kt-scroll-wrappers": "#kt_aside_menu"
}
const _hoisted_2 = {
  id: "#arc_header_menu",
  class: "menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500",
  "data-kt-menu": "true"
}
const _hoisted_3 = {
  key: 0,
  class: "user-info"
}
const _hoisted_4 = { class: "user-avatar" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "user-name" }
const _hoisted_7 = {
  key: 0,
  class: "alias-name-wrapper"
}
const _hoisted_8 = { class: "alias-name" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "user-id"
}
const _hoisted_11 = { class: "m-1" }
const _hoisted_12 = {
  key: 1,
  class: "menu-links"
}
const _hoisted_13 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_14 = { class: "menu-content pt-8 pb-2" }
const _hoisted_15 = { class: "menu-section text-muted text-uppercase fs-8 ls-1" }
const _hoisted_16 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_17 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "menu-title" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_23 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "menu-title" }
const _hoisted_27 = ["href"]
const _hoisted_28 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_29 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_30 = { key: 1 }
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "menu-title" }
const _hoisted_33 = { class: "menu-link" }
const _hoisted_34 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_35 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_36 = { class: "menu-title" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_38 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_40 = { class: "menu-title" }
const _hoisted_41 = { class: "menu-link" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_43 = { class: "menu-title" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_45 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_47 = { class: "menu-title" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_49 = { class: "language-toggle-wrapper p-3 d-flex flex-column mt-auto" }
const _hoisted_50 = { class: "d-flex align-items-center" }
const _hoisted_51 = { class: "select-text" }
const _hoisted_52 = { class: "lang-bttn-group d-flex mx-auto mb-2" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode("English")
const _hoisted_54 = /*#__PURE__*/_createTextVNode("Español")
const _hoisted_55 = { class: "menu-footer" }
const _hoisted_56 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loggedIn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.avatar,
                alt: "avatar"
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_ctx.displayName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.displayName), 1),
                    _createElementVNode("small", {
                      class: "full-name",
                      style: _normalizeStyle({color: _ctx.themeText, fontWeight: 'normal'})
                    }, "(" + _toDisplayString(_ctx.fullName) + ")", 5)
                  ]))
                : (!_ctx.displayName)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.fullName), 1))
                  : _createCommentVNode("", true)
            ]),
            (_ctx.sisId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_inline_svg, {
                    class: "ssid-badge",
                    alt: "icon",
                    src: require('/public/media/icons/ssid-badge.svg')
                  }, null, 8, ["src"]),
                  _createElementVNode("p", _hoisted_11, "SIS ID: " + _toDisplayString(_ctx.sisId), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.loggedIn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MainMenuConfig, (item, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                (item.heading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.translate(item.heading)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pages, (menuItem, j) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                    (menuItem.heading)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.canShow(menuItem))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["menu-item", _ctx.menuItemClass(menuItem)])
                              }, [
                                (!menuItem.externalLink && !menuItem.modalLink)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      class: _normalizeClass(["menu-link", {
                      'active': _ctx.route.name === 'unit' && menuItem.heading === 'menu.assignments',
                      'router-link-exact-active': _ctx.route.name === 'unit' && menuItem.heading === 'menu.assignments',
                    }]),
                                      "active-class": "active",
                                      to: menuItem.route
                                    }, {
                                      default: _withCtx(() => [
                                        (menuItem.svgIcon || menuItem.fontIcon)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                              (_ctx.asideMenuIcons === 'font')
                                                ? (_openBlock(), _createElementBlock("i", {
                                                    key: 0,
                                                    class: _normalizeClass([menuItem.fontIcon, "bi fs-3"])
                                                  }, null, 2))
                                                : (_ctx.asideMenuIcons === 'svg')
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                                      _createVNode(_component_inline_svg, {
                                                        src: menuItem.svgIcon
                                                      }, null, 8, ["src"])
                                                    ]))
                                                  : _createCommentVNode("", true)
                                            ]))
                                          : (!menuItem.svgIcon && !menuItem.fontIcon)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                                _createElementVNode("img", {
                                                  alt: "icon",
                                                  src: menuItem.imageIcon,
                                                  class: "menu-icon"
                                                }, null, 8, _hoisted_19)
                                              ]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["class", "to"]))
                                  : (menuItem.modalLink && _ctx.canShow(menuItem))
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        class: "menu-link menu-link--modal",
                                        "active-class": "active",
                                        onClick: ($event: any) => (_ctx.openModal(menuItem.modalLink))
                                      }, [
                                        (menuItem.svgIcon || menuItem.fontIcon)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                                              (_ctx.asideMenuIcons === 'font')
                                                ? (_openBlock(), _createElementBlock("i", {
                                                    key: 0,
                                                    class: _normalizeClass([menuItem.fontIcon, "bi fs-3"])
                                                  }, null, 2))
                                                : (_ctx.asideMenuIcons === 'svg')
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                                                      _createVNode(_component_inline_svg, {
                                                        src: menuItem.svgIcon
                                                      }, null, 8, ["src"])
                                                    ]))
                                                  : _createCommentVNode("", true)
                                            ]))
                                          : (!menuItem.svgIcon && !menuItem.fontIcon)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                                _createElementVNode("img", {
                                                  alt: "icon",
                                                  src: menuItem.imageIcon,
                                                  class: "menu-icon"
                                                }, null, 8, _hoisted_25)
                                              ]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                                      ], 8, _hoisted_21))
                                    : (menuItem.externalLink && _ctx.canShow(menuItem))
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 2,
                                          class: "menu-link",
                                          "active-class": "active",
                                          href: menuItem.externalLink,
                                          target: "_blank"
                                        }, [
                                          (menuItem.svgIcon || menuItem.fontIcon)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                                                (_ctx.asideMenuIcons === 'font')
                                                  ? (_openBlock(), _createElementBlock("i", {
                                                      key: 0,
                                                      class: _normalizeClass([menuItem.fontIcon, "bi fs-3"])
                                                    }, null, 2))
                                                  : (_ctx.asideMenuIcons === 'svg')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                                                        _createVNode(_component_inline_svg, {
                                                          src: menuItem.svgIcon
                                                        }, null, 8, ["src"])
                                                      ]))
                                                    : _createCommentVNode("", true)
                                              ]))
                                            : (!menuItem.svgIcon && !menuItem.fontIcon)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                                                  _createElementVNode("img", {
                                                    alt: "icon",
                                                    src: menuItem.imageIcon,
                                                    class: "menu-icon"
                                                  }, null, 8, _hoisted_31)
                                                ]))
                                              : _createCommentVNode("", true),
                                          _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                                        ], 8, _hoisted_27))
                                      : _createCommentVNode("", true)
                              ], 2))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    (menuItem.sectionTitle)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass([{ show: _ctx.hasActiveChildren(menuItem.route) }, "menu-item menu-accordion"]),
                          "data-kt-menu-sub": "accordion",
                          "data-kt-menu-trigger": "click"
                        }, [
                          _createElementVNode("span", _hoisted_33, [
                            (menuItem.svgIcon || menuItem.fontIcon)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                                  (_ctx.asideMenuIcons === 'font')
                                    ? (_openBlock(), _createElementBlock("i", {
                                        key: 0,
                                        class: _normalizeClass([menuItem.fontIcon, "bi fs-3"])
                                      }, null, 2))
                                    : (_ctx.asideMenuIcons === 'svg')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                                          _createVNode(_component_inline_svg, {
                                            src: menuItem.svgIcon
                                          }, null, 8, ["src"])
                                        ]))
                                      : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.translate(menuItem.sectionTitle)), 1),
                            _hoisted_37
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass([{ show: _ctx.hasActiveChildren(menuItem.route) }, "menu-sub menu-sub-accordion"])
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.sub, (item2, k) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                                (item2.heading)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                      _createVNode(_component_router_link, {
                                        class: "menu-link",
                                        "active-class": "active",
                                        to: item2.route
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_39,
                                          _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.translate(item2.heading)), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (item2.sectionTitle)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: _normalizeClass([{ show: _ctx.hasActiveChildren(item2.route) }, "menu-item menu-accordion"]),
                                      "data-kt-menu-sub": "accordion",
                                      "data-kt-menu-trigger": "click"
                                    }, [
                                      _createElementVNode("span", _hoisted_41, [
                                        _hoisted_42,
                                        _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.translate(item2.sectionTitle)), 1),
                                        _hoisted_44
                                      ]),
                                      _createElementVNode("div", {
                                        class: _normalizeClass([{ show: _ctx.hasActiveChildren(item2.route) }, "menu-sub menu-sub-accordion"])
                                      }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.sub, (item3, k) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                                            (item3.heading)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                                  _createVNode(_component_router_link, {
                                                    class: "menu-link",
                                                    "active-class": "active",
                                                    to: item3.route
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_46,
                                                      _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.translate(item3.heading)), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["to"])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        }), 128))
                                      ], 2)
                                    ], 2))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ], 2)
                        ], 2))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ], 64))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _hoisted_48,
      _createElementVNode("div", _hoisted_49, [
        _createElementVNode("span", _hoisted_50, [
          _createVNode(_component_inline_svg, {
            class: "menu-icon",
            src: require('/public/media/icons/globe.svg')
          }, null, 8, ["src"]),
          _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.$t('menu.selectLanguage')), 1)
        ]),
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeLanguage('en'))),
            class: _normalizeClass([{active: _ctx.$i18n.locale === 'en'}, "w-50 p-2 d-flex align-items-center justify-content-center"]),
            id: "toggle-english"
          }, [
            (_ctx.$i18n.locale === 'en')
              ? (_openBlock(), _createBlock(_component_inline_svg, {
                  key: 0,
                  src: require('/public/media/icons/check-icon-black.svg'),
                  style: _normalizeStyle({marginRight: '0.5em'})
                }, null, 8, ["src", "style"]))
              : _createCommentVNode("", true),
            _hoisted_53
          ], 2),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLanguage('es'))),
            class: _normalizeClass([{active: _ctx.$i18n.locale === 'es'}, "w-50 p-2 d-flex align-items-center justify-content-center"]),
            id: "toggle-spanish"
          }, [
            (_ctx.$i18n.locale === 'es')
              ? (_openBlock(), _createBlock(_component_inline_svg, {
                  key: 0,
                  src: require('/public/media/icons/check-icon-black.svg'),
                  style: _normalizeStyle({marginRight: '0.5em'})
                }, null, 8, ["src", "style"]))
              : _createCommentVNode("", true),
            _hoisted_54
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("img", {
          alt: "logo",
          src: require('/public/media/logos/app-logo.png')
        }, null, 8, _hoisted_56)
      ])
    ])
  ], 512))
}